import { chain } from '@leprecoins/effector';
import { createEvent } from 'effector';
import { adminLayoutModel } from 'pages/admin-layout';
import { breakpoints, translations } from 'shared/lib';

export const appStarted = createEvent();

chain(appStarted, translations.setup);

chain(appStarted, breakpoints.setup);

chain(appStarted, adminLayoutModel.setup);
